"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuroraThemeDark = void 0;
var _variables_json_1 = __importDefault(require("@careem-public/aurora-tokens/styles/json/_variables.json"));
exports.AuroraThemeDark = {
    token: {
        // SeedToken - Core tokens =================================================
        // Using success colour instead of careen, because careem colour is not accessible
        colorPrimary: _variables_json_1.default.background.state.successHighEmphasize,
        colorBgBase: _variables_json_1.default.background.primary,
        colorTextBase: _variables_json_1.default.text.primary,
        colorInfo: _variables_json_1.default.background.state.infoHighEmphasize,
        colorError: _variables_json_1.default.background.state.dangerHighEmphasize,
        colorSuccess: _variables_json_1.default.background.state.successHighEmphasize,
        colorWarning: _variables_json_1.default.background.state.warningHighEmphasize,
        // MapTokens - "Semantic tokens" =================================================
        // Text colours ===============
        colorText: _variables_json_1.default.text.primary,
        colorTextSecondary: _variables_json_1.default.text.secondary,
        colorTextTertiary: _variables_json_1.default.text.tertiary,
        // !!!! Used for placeholder not only for text but for background
        // colorTextQuaternary: "#ff00ff", // CHECK: Where it is used? // The fourth level of text color is the lightest text color, such as form input prompt text, disabled color text, etc.
        colorTextQuaternary: _variables_json_1.default.text.placeholder,
        colorPrimaryText: _variables_json_1.default.text.primary,
        // colorPrimaryTextActive: "#ff00ff", // CHECK: Where it is used? // Active state of text color under the main color gradient.
        // colorPrimaryTextHover: "#ff00ff", // CHECK: Where it is used? // Hover state of text color under the main color gradient.
        colorInfoText: _variables_json_1.default.text.state.info,
        // colorInfoTextActive: "#ff00ff", // CHECK: Where it is used? // Active state of text color of information color.
        // colorInfoTextHover: "#ff00ff", // CHECK: Where it is used? // Hover state of text color of information color.
        colorSuccessText: _variables_json_1.default.text.state.success,
        // colorSuccessTextActive: "#ff00ff", // CHECK: Where it is used? // Active state color of success color text
        // colorSuccessTextHover: "#ff00ff", // CHECK: Where it is used? // Hover state color of success color text
        colorErrorText: _variables_json_1.default.text.state.danger,
        // colorErrorTextActive: "#ff00ff", // CHECK: Where it is used? // The active state of the text in the error color.
        // colorErrorTextHover: "#ff00ff", // CHECK: Where it is used? // The hover state of the text in the error color.
        colorWarningText: _variables_json_1.default.text.state.warning,
        // colorWarningTextActive: "#ff00ff", // CHECK: Where it is used? // The active state of the text in the warning color.
        // colorWarningTextHover: "#ff00ff", // CHECK: Where it is used? // The hover state of the text in the warning color.
        colorTextDisabled: _variables_json_1.default.text.state.disabled,
        colorTextDescription: _variables_json_1.default.text.secondary,
        colorTextHeading: _variables_json_1.default.text.primary,
        colorTextLabel: _variables_json_1.default.text.primary,
        // colorTextLightSolid: "#ff00ff", // CHECK: Where it is used? // Control the highlight color of text with background color, such as the text in Primary Button components.
        // colorTextPlaceholder: "#ff00ff", // CHECK: Where it is used? // Control the color of placeholder text.
        // Background colours ===============
        // colorWhite: auroraColor.grey[50], // Pure white color don't changed by theme
        // colorBgTextActive: "#ff00ff", // CHECK: Where it is used? // Control the background color of text in active state.
        // colorBgTextHover: "#ff00ff", // CHECK: Where it is used? // Control the background color of text in hover state.
        colorBgContainer: _variables_json_1.default.background.primary,
        colorBgElevated: _variables_json_1.default.background.primary,
        colorBgLayout: _variables_json_1.default.background.primary,
        // colorBgMask: "#ff00ff", // CHECK: Where it is used? // The background color of the mask, used to cover the content below the mask, Modal, Drawer and other components use this token
        colorBgSpotlight: _variables_json_1.default.background.state.infoHighEmphasize,
        // colorFill: "#ff00ff", // CHECK: Where it is used? // The darkest fill color is used to distinguish between the second and third level of fill color, and is currently only used in the hover effect of Slider.
        // colorPrimaryBg: "#ff00ff", // CHECK: Where it is used? // Light background color of primary color, usually used for weak visual level selection state.
        // colorPrimaryActive: "#ff00ff", // CHECK: Where it is used? // Dark active state under the main color gradient.
        // colorPrimaryBgHover: "#ff00ff", // CHECK: Where it is used? // The hover state color corresponding to the light background color of the primary color.
        // colorPrimaryHover: "#ff00ff", // CHECK: Where it is used? // Hover state under the main color gradient.
        colorFillSecondary: _variables_json_1.default.background.secondary,
        colorFillTertiary: _variables_json_1.default.background.tertiary,
        // colorFillQuaternary: "#ff00ff", // CHECK: Where it is used? // The weakest level of fill color is suitable for color blocks that are not easy to attract attention, such as zebra stripes, color blocks that distinguish boundaries, etc.
        colorInfoBg: _variables_json_1.default.background.state.infoMidEmphasize,
        colorInfoActive: _variables_json_1.default.background.state.infoHighEmphasize,
        // colorInfoBgHover: "#ff00ff", // CHECK: Where it is used? // 	Hover state of light background color of information color.
        // colorInfoHover: "#ff00ff", // CHECK: Where it is used? // Hover state of dark color of information color.
        colorSuccessBg: _variables_json_1.default.background.state.successMidEmphasize,
        colorSuccessActive: _variables_json_1.default.background.state.successHighEmphasize,
        // colorSuccessBgHover: "#ff00ff", // CHECK: Where it is used? // Light background color of success color, but antd does not use this token currently
        // colorSuccessHover: "#ff00ff", // CHECK: Where it is used? // Hover state color of dark success color
        colorErrorBg: _variables_json_1.default.background.state.dangerMidEmphasize,
        colorErrorActive: _variables_json_1.default.background.state.dangerHighEmphasize,
        // colorErrorBgHover: "#ff00ff", // CHECK: Where it is used? // The hover state background color of the error state.
        // colorErrorHover: "#ff00ff", // CHECK: Where it is used? // The hover state of the error color.
        colorWarningBg: _variables_json_1.default.background.state.warningMidEmphasize,
        colorWarningActive: _variables_json_1.default.background.state.warningHighEmphasize,
        // colorWarningBgHover: "#ff00ff", // CHECK: Where it is used? // The hover state background color of the warning state.
        // colorWarningHover: "#ff00ff", // CHECK: Where it is used? // The hover state of the warning color.
        colorBgContainerDisabled: _variables_json_1.default.background.state.disabled,
        colorFillContent: _variables_json_1.default.background.primary,
        // colorFillAlter: "#ff00ff", // CHECK: Where it is used? // Control the alternative background color of element.
        // colorFillContentHover: "#ff00ff", // CHECK: Where it is used? // Control the style of background color of content area when mouse hovers over it.
        // Border colours ===============
        colorBorder: _variables_json_1.default.border.primary,
        colorBorderSecondary: _variables_json_1.default.border.secondary,
        // colorBorderBg: "#ff00ff", // CHECK: Where it is used? // Control the color of background border of element.
        colorPrimaryBorder: _variables_json_1.default.border.primary,
        colorPrimaryBorderHover: _variables_json_1.default.border.state.hover,
        colorInfoBorder: _variables_json_1.default.border.state.infoMidEmphasize,
        colorInfoBorderHover: _variables_json_1.default.border.state.hover,
        colorSuccessBorder: _variables_json_1.default.border.state.successHighEmphasize,
        colorSuccessBorderHover: _variables_json_1.default.border.state.hover,
        colorErrorBorder: _variables_json_1.default.border.state.dangerHighEmphasize,
        colorErrorBorderHover: _variables_json_1.default.border.state.hover,
        colorErrorOutline: _variables_json_1.default.border.state.dangerHighEmphasize,
        colorWarningBorder: _variables_json_1.default.border.state.warningHighEmphasize,
        colorWarningBorderHover: _variables_json_1.default.border.state.hover,
        colorWarningOutline: _variables_json_1.default.border.state.warningHighEmphasize,
        // Icon colours ===============
        colorIcon: _variables_json_1.default.icon.primary,
        colorIconHover: _variables_json_1.default.icon.state.success, // 	Weak action hover color. Such as `allowClear` or Alert close button
    },
    // Components - "Component specific tokens" =================================================
    components: {
        Avatar: {
            // colorBorderBg: "#8A5C02", // NEED to Check
            colorText: _variables_json_1.default.text.tertiary,
            colorTextLightSolid: _variables_json_1.default.text.tertiary,
            colorTextPlaceholder: _variables_json_1.default.background.state.infoMidEmphasize, // Background
        },
        Badge: {
        // colorBgContainer: "#ff00ff",
        // colorBorderBg: auroraColor.border.primary,
        // colorError: auroraColor.background.state.dangerHighEmphasize,
        // colorErrorHover: auroraColor.background.state.dangerMidEmphasize,
        // colorPrimary: auroraColor.background.brand.careem,
        // colorSuccess: auroraColor.background.state.successMidEmphasize,
        // colorText: auroraColor.text.primary,
        // colorTextLightSolid: auroraColor.text.primaryInverse,
        // colorTextPlaceholder: auroraColor.text.placeholder,
        // colorWarning: auroraColor.background.state.warningMidEmphasize,
        },
        Button: {
            colorPrimary: _variables_json_1.default.components.button.primary.background.default,
            colorPrimaryActive: _variables_json_1.default.components.button.primary.background.pressed,
            colorPrimaryBorder: _variables_json_1.default.components.button.primary.border.default,
            colorPrimaryHover: _variables_json_1.default.components.button.primary.background.hover,
            colorText: _variables_json_1.default.components.button.tertiary.text.default,
            colorTextLightSolid: _variables_json_1.default.components.button.primary.text.default,
            colorBorder: _variables_json_1.default.components.button.tertiary.border.default,
            colorBgContainer: _variables_json_1.default.components.button.tertiary.background.default,
            colorBgTextActive: _variables_json_1.default.components.button.tertiary.background.pressed,
            colorBgTextHover: _variables_json_1.default.components.button.tertiary.background.hover,
            colorLink: _variables_json_1.default.components.link.primary.text.default,
            colorLinkActive: _variables_json_1.default.components.link.primary.text.pressed,
            colorLinkHover: _variables_json_1.default.components.link.primary.text.hover,
            colorTextDisabled: _variables_json_1.default.components.button.primary.text.disabled,
            colorBgContainerDisabled: _variables_json_1.default.components.button.primary.background.disabled,
            // controlOutline: "#ff00ff", //
            // controlTmpOutline: "#ff00ff", //
            // Removing the shadow from the button
            controlOutline: 'rgba(#fff,0.0)',
            controlTmpOutline: 'rgba(#fff,0.0)',
            // colorError: "#ff00ff",
            // colorErrorActive: "#ff00ff",
            // colorErrorBg: "#ff00ff",
            // colorErrorBorderHover: "#ff00ff",
            // colorErrorHover: "#ff00ff",
            // colorErrorOutline: "#ff00ff",
        },
        Segmented: {
            colorBgElevated: _variables_json_1.default.background.primary,
            colorBgLayout: _variables_json_1.default.background.secondary,
            // !!!! Text on Hover broken
            colorFillSecondary: '#ff00ff',
            colorText: _variables_json_1.default.text.primary,
            // colorTextDisabled: auroraColor.text.state.disabled, //
            colorTextLabel: _variables_json_1.default.text.primary, //
            // boxShadowTertiary: "#ff00ff", //
        },
        Tabs: {
            colorBgContainer: _variables_json_1.default.background.primary,
            // colorBorder: "#ff00ff", //
            colorBorderSecondary: _variables_json_1.default.border.primary,
            colorFillAlter: _variables_json_1.default.background.secondary, //
            // colorPrimary: "#ff00ff", //
            // colorPrimaryActive: "#ff00ff", //
            // colorPrimaryBorder: "#ff00ff", //
            // colorPrimaryHover: "#ff00ff", //
            // colorText: "#ff00ff", //
            // colorTextDescription: "#ff00ff", //
            // colorTextDisabled: "#ff00ff", //
            // colorTextHeading: "#ff00ff", //
            // controlItemBgHover: "#ff00ff", //
        },
        Input: {
        // colorErrorText: "#8A5C02",
        },
    },
};
